import { createAsyncThunk } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import axiosInstance from 'utils/axios';

export const getLoyaltyPointDashboard = createAsyncThunk(
  'loyaltyPointDashboard/getLoyaltyPointDashboard',
  async (params, thunkAPI) => {
    const {
      page,
      limit,
      search,
      activityType,
      periodType,
      userStartDate,
      userEndDate,
      summaryStartDate,
      summaryEndDate,
    } = params;

    let newUrl = `/admin/loyalty-points/dashboard`;

    if (page) {
      if (newUrl.includes('?')) {
        newUrl += `&page=${page}`;
      } else {
        newUrl += `?page=${page}`;
      }
    }

    if (limit) {
      if (newUrl.includes('?')) {
        newUrl += `&limit=${limit}`;
      } else {
        newUrl += `?limit=${limit}`;
      }
    }

    if (search) {
      if (newUrl.includes('?')) {
        newUrl += `&search=${search}`;
      } else {
        newUrl += `?search=${search}`;
      }
    }

    if (activityType) {
      if (newUrl.includes('?')) {
        newUrl += `&activity_type=${activityType}`;
      } else {
        newUrl += `?activity_type=${activityType}`;
      }
    }

    if (periodType) {
      if (newUrl.includes('?')) {
        newUrl += `&period_type=${periodType}`;
      } else {
        newUrl += `?period_type=${periodType}`;
      }
    }

    if (userStartDate) {
      if (newUrl.includes('?')) {
        newUrl += `&user_start_date=${userStartDate}`;
      } else {
        newUrl += `?user_start_date=${userStartDate}`;
      }
    }

    if (userEndDate) {
      if (newUrl.includes('?')) {
        newUrl += `&user_end_date=${userEndDate}`;
      } else {
        newUrl += `?user_end_date=${userEndDate}`;
      }
    }

    if (summaryStartDate) {
      if (newUrl.includes('?')) {
        newUrl += `&summary_start_date=${summaryStartDate}`;
      } else {
        newUrl += `?summary_start_date=${summaryStartDate}`;
      }
    }

    if (summaryEndDate) {
      if (newUrl.includes('?')) {
        newUrl += `&summary_end_date=${summaryEndDate}`;
      } else {
        newUrl += `?summary_end_date=${summaryEndDate}`;
      }
    }

    try {
      const response = await axiosInstance.get(newUrl);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const exportUserLoyaltyPointDashboard = createAsyncThunk(
  'loyaltyPointDashboard/exportUserLoyaltyPointDashboard',
  async (params, thunkAPI) => {
    const { search, userStartDate, userEndDate } = params;

    let newUrl = `/admin/loyalty-points/dashboard/users/export`;

    if (search) {
      if (newUrl.includes('?')) {
        newUrl += `&search=${search}`;
      } else {
        newUrl += `?search=${search}`;
      }
    }

    if (userStartDate) {
      if (newUrl.includes('?')) {
        newUrl += `&user_start_date=${userStartDate}`;
      } else {
        newUrl += `?user_start_date=${userStartDate}`;
      }
    }

    if (userEndDate) {
      if (newUrl.includes('?')) {
        newUrl += `&user_end_date=${userEndDate}`;
      } else {
        newUrl += `?user_end_date=${userEndDate}`;
      }
    }

    try {
      const response = await axiosInstance.get(newUrl, {
        responseType: 'blob',
      });
      const dateNow = format(new Date(), 'MM-dd-yyyy-hh-mm-ss');
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `loyalty-point-report-${dateNow}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getUserLoyaltyExperience = createAsyncThunk(
  'userLoyaltyExperience/getUserLoyaltyExperience',
  async (params, thunkAPI) => {
    const { page, limit, userId } = params;

    let newUrl = `/admin/loyalty-experiences`;

    if (page) {
      if (newUrl.includes('?')) {
        newUrl += `&page=${page}`;
      } else {
        newUrl += `?page=${page}`;
      }
    }

    if (limit) {
      if (newUrl.includes('?')) {
        newUrl += `&limit=${limit}`;
      } else {
        newUrl += `?limit=${limit}`;
      }
    }

    if (userId) {
      if (newUrl.includes('?')) {
        newUrl += `&user_id=${userId}`;
      } else {
        newUrl += `?user_id=${userId}`;
      }
    }

    try {
      const response = await axiosInstance.get(newUrl);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getUserLoyaltyHistory = createAsyncThunk(
  'userLoyaltyHistory/getUserLoyaltyHistory',
  async (params, thunkAPI) => {
    const { page, limit, userId } = params;

    let newUrl = `/admin/loyalty-point-history`;

    if (page) {
      if (newUrl.includes('?')) {
        newUrl += `&page=${page}`;
      } else {
        newUrl += `?page=${page}`;
      }
    }

    if (limit) {
      if (newUrl.includes('?')) {
        newUrl += `&limit=${limit}`;
      } else {
        newUrl += `?limit=${limit}`;
      }
    }

    if (userId) {
      if (newUrl.includes('?')) {
        newUrl += `&user_id=${userId}`;
      } else {
        newUrl += `?user_id=${userId}`;
      }
    }

    try {
      const response = await axiosInstance.get(newUrl);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);
